export const TIMEOUT_TRESHOLD = 4000


// WEBPACK FOOTER //
// ./src/constants/index.js